export default "__VITE_ASSET__BDtNFIv5__"